class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);

    this.addEventListener("click", this.onClick);
  }

  onClick(e) {
    // Close the cart if the user clicks outside of the cart
    const isCloseButton = e.target.closest("#close");

    if (e.target.id === "cart" || isCloseButton) {
      e.preventDefault();

      if (window.location.pathname === "/cart") {
        window.location.href = "/";
      } else {
        this.closeDrawer();
      }
    }
  }

  openDrawer() {
    this.setAttribute("open", "true");
  }

  closeDrawer() {
    this.removeAttribute("open");
  }

  async updateQuantity(itemId, quantity) {
    await fetch("/cart/change", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemId,
        quantity: quantity,
      }),
    }).then((res) => {
      console.log(res);
    });
    // Update the cart drawer after the quantity change
    await this.update();
  }

  async update() {
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const cartDrawer = document.getElementById("cart");
    if (cartDrawer) {
      cartDrawer.innerHTML = html.querySelector("#cart").innerHTML;
    }

    // Update the cart count in the header
    const cartItemCount = document.getElementById("cart-item-count");

    console.log(html, "html");
    console.log("cartItemCount", cartItemCount);
    // set to nothing if 0, otherwise set to the cart item count
    cartItemCount.textContent =
      html.querySelector("#item-count-helper").textContent || "";
  }

  async addToCart(form) {
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });
    // update cart
    await this.update().then(() => {
      this.openDrawer();
    });
  }

  async addObjectToCart(object) {
    await fetch("/cart/add.js", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(object),
    });

    // update cart
    await this.update().then(() => {
      this.openDrawer();
    });
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class CartItem extends HTMLElement {
  constructor() {
    super();
    // bind click event to button id decrease
    this.decreaseButton = this.querySelector("button[id='decrease']");
    this.increaseButton = this.querySelector("button[id='increase']");
    // this.quantity = parseInt(this.querySelector("p[id='quantity']").innerHTML);

    this.pid = this.getAttribute("data-product-id");
    // this.handleQuantity = this.handleQuantity.bind(this);

    //this.decreaseButton.addEventListener("click", this.handleQuantity);
    //this.increaseButton.addEventListener("click", this.handleQuantity);
  }

  // async handleQuantity(e) {
  //   console.log(e.target.id);
  //   if (e.target.id === "decrease") {
  //     if (parseInt(this.quantity) === 1) {
  //       console.log("too low");
  //     }
  //     if (parseInt(this.quantity) > 1) {
  //       document
  //         .querySelector("cart-drawer")
  //         .updateQuantity(this.pid, this.quantity - 1);
  //       console.log("decrease it by 1 bro");
  //     }
  //   }
  //   if (e.target.id === "increase") {
  //     document
  //       .querySelector("cart-drawer")
  //       .updateQuantity(this.pid, this.quantity + 1);
  //   }
  //   e.preventDefault();
  //   console.log(this.pid, this.quantity);
  // }
}

if (!customElements.get("cart-item")) {
  customElements.define("cart-item", CartItem);
}

class SlideShow extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupMarkup();
    this.initSwiper();
  }

  setupMarkup() {
    // Create base Swiper structure
    const swiperContainer = document.createElement("div");
    swiperContainer.classList.add("swiper");

    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-wrapper");

    // Move all existing children into swiper-slide wrappers
    Array.from(this.children).forEach((child) => {
      const slide = document.createElement("div");
      slide.classList.add("swiper-slide");
      slide.appendChild(child);
      wrapper.appendChild(slide);
    });

    swiperContainer.appendChild(wrapper);

    // Clear original content and append structured swiper
    this.innerHTML = "";
    this.appendChild(swiperContainer);
  }

  initSwiper() {
    const swiperEl = this.querySelector(".swiper");

    if (swiperEl) {
      this.swiper = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: this.getAttribute("data-gap")
          ? parseInt(this.getAttribute("data-gap"))
          : 12,
        loop: true,
        centeredSlides: false,
        speed: 300,
        mousewheel: {
          forceToAxis: true,
        },
      });
    }
  }
}

if (!customElements.get("swiper-gallery")) {
  customElements.define("swiper-gallery", SlideShow);
}

class HeaderCart extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick);
  }

  onClick(e) {
    e.preventDefault();
    document.querySelector("cart-drawer").openDrawer();
  }
}

if (!customElements.get("header-cart")) {
  customElements.define("header-cart", HeaderCart);
}

class RemoveButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick);
  }

  async onClick(e) {
    e.preventDefault();

    const form = this.closest("form");

    await fetch(e.target.href, {
      method: "post",
      body: new FormData(form),
    });

    // Fetch the updated cart data to check if it's empty
    const response = await fetch("/cart.js");
    const cartData = await response.json();

    // If the cart is empty, close the drawer
    if (cartData.item_count === 0) {
      document.querySelector("cart-drawer").closeDrawer();
    }

    // Update the cart drawer after removing the item
    await document.querySelector("cart-drawer").update();
  }
}

if (!customElements.get("remove-button")) {
  customElements.define("remove-button", RemoveButton);
}
